var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalPost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3332 2.99998C27.3332 1.53331 26.1332 0.333313 24.6665 0.333313H3.33317C1.8665 0.333313 0.666504 1.53331 0.666504 2.99998V19C0.666504 20.4666 1.8665 21.6666 3.33317 21.6666H24.6665C26.1332 21.6666 27.3332 20.4666 27.3332 19V2.99998ZM24.6665 2.99998L13.9998 9.66665L3.33317 2.99998H24.6665ZM13.9998 12.3333L3.33317 5.66665V19H24.6665V5.66665L13.9998 12.3333Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalPost);
export default __webpack_public_path__ + "static/media/local_post.d92ad29fb3c3d5ba6ae5aa59c6f2d22c.svg";
export { ForwardRef as ReactComponent };